import { IconButton, Toast } from '@lexhero/park-ui';
import {
    Bell,
    CircleAlert,
    CircleCheck,
    Info,
    TriangleAlert,
    XIcon,
} from 'lucide-react';
import useTypedIntl from '../../lang/utils/useTypedIntl';
import styles from './toastContainerParkUi.module.css';

export interface toastContext {
    id: string;
    title: string;
    description?: string;
    type: 'info' | 'success' | 'error' | 'warning' | 'neutral';
    duration?: number;
    removeDelay?: number;
    gap?: number;
    stacked?: boolean;
}

export const toaster = Toast.createToaster({
    placement: 'bottom-end',
    overlap: true,
    gap: 16,
});

export default function ToastContainerParkUi() {
    const { translate } = useTypedIntl();

    return (
        <Toast.Toaster toaster={toaster}>
            {(toast: toastContext) => {
                const ToastIcon = {
                    success: CircleCheck,
                    error: CircleAlert,
                    warning: TriangleAlert,
                    info: Info,
                    neutral: Bell,
                }[toast.type];

                return (
                    <Toast.Root
                        key={toast.id}
                        className={`${styles.toastContainer} ${
                            !toast.description ? styles.withoutDescription : ''
                        }`}
                    >
                        <span className={styles.icon} aria-hidden="true">
                            <ToastIcon size={18} strokeWidth={2.25} />
                        </span>
                        <div className={styles.content}>
                            <Toast.Title>{toast.title}</Toast.Title>
                            {toast.description && (
                                <Toast.Description>
                                    {toast.description}
                                </Toast.Description>
                            )}
                        </div>
                        <Toast.CloseTrigger asChild>
                            <IconButton
                                aria-label={translate('Chiudi')}
                                className={styles.closeButton}
                                size="sm"
                                variant="link"
                                data-cy="toast-close"
                            >
                                <XIcon size={16} />
                            </IconButton>
                        </Toast.CloseTrigger>
                    </Toast.Root>
                );
            }}
        </Toast.Toaster>
    );
}
